module.exports = __webpack_public_path__ + "img/cjjl.abea6642.png";